export const PAGE_SIZES = [10, 25, 50, 100] as const

export const DEFAULT_PAGE_SIZE = 25

export const DEFAULT_PAGE = 1

export const DEBOUNCE_DELAY = 300

export const DEFAULT_SORTING = [
  {
    id: 'created_at',
    desc: true,
  },
]

export const ROW_HEIGHT_ESTIMATE = 35

export const VIRTUALIZER_OVERSCAN = 10

export type Product = {
  id: string
  item_name: string
  item_name_translations: string | null
  item_description: string
  article_number: string
  image_urls: string[]
  created_at: string
  source: string
  final_price: number
  product_variant: any[]
}
